module.exports = __webpack_public_path__ + "img/56cf7b7.png";